import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-svg-definitions',
    templateUrl: './svg-definitions.component.html',
    styleUrls: ['./svg-definitions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SvgDefinitionsComponent implements OnInit {

  public iconColor: string = '';

  // from cms we only get the svg as image with black fill. so we need a filter to manipulate the color.
  // the filter reduces specific tones of color, so it has the same color like the font. To get the parameters
  // go to a color matrix mixer, load the svg from cms and change the offsets to get the prefered color.
  private colorDefault: string = '0 0 0 0 0.04 0 0 0 0 0.04 0 0 0 0 0.04 0 0 0 1 0';

  constructor() { }

  ngOnInit() {
    this.iconColor = this.colorDefault;
  }

}
